// extracted by mini-css-extract-plugin
module.exports = {"container":"mini-cart-button_container__M8Art","icon":"mini-cart-button_icon__oi0hF","label":"mini-cart-button_label__0siVa"};